import React from 'react';
import classnames from 'classnames';
import s from './GroupOperationButton.scss';
export class GroupOperationButton extends React.Component {
    render() {
        const { className , children , onClick , disabled  } = this.props;
        return /*#__PURE__*/ React.createElement("button", {
            className: classnames(s['group-operation-button'], className),
            disabled: disabled,
            onClick: onClick
        }, children);
    }
}
export default GroupOperationButton;
